import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const AdminTrxServices = {
  getSumAdminTrx,
  getAdminTrx,
  adminUpdateTrx,
  adminSukseskanTrx
}

function adminSukseskanTrx (postdata) {
  return fetch(API_URL + '/api/admin/v1/transaction', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function adminUpdateTrx (data) {
  return fetch(API_URL + '/api/admin/v1/transaction/' + data.idtrx + '/' + data.status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSumAdminTrx () {
  return fetch(API_URL + '/api/admin/v1/transactions/today', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getAdminTrx (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('sortbytrxbeli')
    } else {
      localStorage.setItem('sortbytrxbeli', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    } else {
      sorder = 'ASC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/admin/v1/transactions?search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
